/**
 * ColorWare Direct — Gallery Carousel
 * Prev/next image navigation with keyboard and touch support.
 */
(function () {
  'use strict';

  var gallery = document.querySelector('.cwd-gallery');
  if (!gallery) return;

  var track   = gallery.querySelector('.cwd-gallery__track');
  var slides  = gallery.querySelectorAll('.cwd-gallery__slide');
  var prevBtn = gallery.querySelector('.cwd-gallery__prev');
  var nextBtn = gallery.querySelector('.cwd-gallery__next');

  if (!track || slides.length < 2) {
    if (prevBtn) prevBtn.hidden = true;
    if (nextBtn) nextBtn.hidden = true;
    return;
  }

  var current = 0;
  var total   = slides.length;

  function update() {
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    prevBtn.disabled = (current === 0);
    nextBtn.disabled = (current === total - 1);
  }

  prevBtn.addEventListener('click', function () {
    if (current > 0) { current--; update(); }
  });

  nextBtn.addEventListener('click', function () {
    if (current < total - 1) { current++; update(); }
  });

  /* Keyboard navigation when gallery area is focused */
  gallery.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft')  prevBtn.click();
    if (e.key === 'ArrowRight') nextBtn.click();
  });

  /* Swipe support for touch devices */
  var touchStartX = 0;
  var viewport = gallery.querySelector('.cwd-gallery__viewport');

  viewport.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  viewport.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) nextBtn.click();   /* swipe left  → next */
      else          prevBtn.click();   /* swipe right → prev */
    }
  }, { passive: true });

  update();
})();
